import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './GarageConfigurator';

export type {
	GarageConfiguratorFields,
	Props,
	Texts,
} from './GarageConfigurator';

const GarageConfiguratorSuspense = dynamic(
	() => import('./GarageConfigurator'),
	{
		loading: () => <BlockLoadingSpinner />,
		// Intended to solve an issue where import of react-konva-utils
		// leads to an import race condition exception. Seems a bit odd and hacky
		// but no better solutions have been found, and it does not need to be server
		// rendered anyway, so do this for now.
		ssr: false,
	},
);

export default function DynamicGarageConfigurator(props: Props) {
	return <GarageConfiguratorSuspense {...props} />;
}
DynamicGarageConfigurator.displayName = 'DynamicGarageConfigurator';
